// ** React Imports
import React, {
  Fragment,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from "react";

// ** Custom Components
import UILoader from "@components/ui-loader";
import Spinner from "@components/spinner/Loading-spinner";
import {
  GenerateSortingIndicator,
  NormalColumn,
  StatusColumn,
  FlexTimeListColumn,
  DateRangeColumn,
  InuseColumn,
} from "../../../../components/common/TableColumn";

import { ToastMessageError } from "../../../../components/common/ToastMessage";

// ** Reactstrap Imports
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Row,
  Col,
  Label,
  Input,
  Button,
  CardText,
  Table,
  CardSubtitle,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// ** Icon
import { MoreVertical, Trash } from "react-feather";

// ** Third Party Components
import { useTable, useSortBy, usePagination } from "react-table";
import moment from "moment";

// ** Custom Hook
// import { useSearchFlexTimeHistory } from "../../../../utility/hooks/react-query/useFlexTimeData";
import { useSearchHistoryInFlowManager } from "../../../../utility/hooks/react-query/useFlexTimeData";

// ** Components

import NoResultsFound from "../../../../components/common/NoResultsFound";

import { getUserName } from "../../../../auth/LoginUser";
import { useTranslation } from "react-i18next";
// import { FlexTimeHistoryDeleteModal } from "./FlexTimeHistoryModal";

// ** Function
const getUrlParamSearch = (
  queryPageIndex,
  queryPageSize,
  querySortBy,
  {
    requestDate = "",
    flexTimeType = "",
    status = "",
    employeeCode = "",
    employeeName = "",
    employeeDept = "",
  },
  startDate = "",
  endDate = ""
) => {
  requestDate = requestDate[0];
  let params = ``;
  params += `"FLEX_TIME_REQUEST_DATE":"${
    requestDate ? moment(requestDate).format("YYYY-MM-DD") : ``
  }"`;
  params += `, "FLEX_TIME_TYPE_ID":"${flexTimeType?.FLEX_TIME_TYPE_ID || ""}"`;
  params += `,"START_DATE":"${
    startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : `${new Date().getFullYear()}-01-01`
  }"`;
  params += `,"END_DATE":"${
    endDate
      ? moment(endDate).add(1, "d").format("YYYY-MM-DD")
      : `${new Date().getFullYear()}-12-31`
  }"`;
  params += `, "EMPLOYEE_ID_REQUEST":"${getUserName()}"`;
  params += `, "EMPLOYEE_ID":"${employeeCode}"`;
  params += `, "EMPLOYEE_NAME":"${employeeName}"`;
  params += `, "EMPLOYEE_SECTION":"${employeeDept?.SECTION || ""}"`;
  params += `, "Start":"${queryPageIndex}"`;
  params += `, "Limit":"${queryPageSize}"`;
  if (querySortBy?.length > 0) {
    params += `, "Order":${JSON.stringify(querySortBy).replace(
      "MODIFIED_DATE",
      "UPDATE_DATE"
    )}`;
  }
  params = `{${params}}`;
  return params;
};

// ** Initial Data
const initialState = {
  queryPageIndex: 0,
  queryPageSize: 5,
  totalCount: null,
  querySortBy: [],
};

// ** Redux
const PAGE_CHANGED = "PAGE_CHANGED";
const PAGE_SIZE_CHANGED = "PAGE_SIZE_CHANGED";
const PAGE_SORT_CHANGED = "PAGE_SORT_CHANGED";
const TOTAL_COUNT_CHANGED = "TOTAL_COUNT_CHANGED";

const reducer = (state, { type, payload }) => {
  switch (type) {
    case PAGE_CHANGED:
      return {
        ...state,
        queryPageIndex: payload,
      };
    case PAGE_SIZE_CHANGED:
      return {
        ...state,
        queryPageSize: payload,
      };
    case PAGE_SORT_CHANGED:
      return {
        ...state,
        querySortBy: payload,
      };
    case TOTAL_COUNT_CHANGED:
      return {
        ...state,
        totalCount: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};

const CheckSubordinateFlexTimeTableData = ({
  refTableData,
  isFetchData,
  setIsFetchData,
  getValues,
  refRowSelected,
  clearFilterFormSearch,
  setIsSearchDataForSearchForm,
  setStartPicker,
  startPicker,
  setEndPicker,
  endPicker,
}) => {
  const [isShowUploadFileModel, setIsShowUploadFileModel] = useState(false);
  const [isShowDeleteFlexTimeModel, setIsShowDeleteFlexTimeModel] =
    useState(false);

  // const { t } = useTranslation();
  const { t } = useTranslation("Table Data", {
    keyPrefix: "Utility.Table Data",
  });

  const onClickDelete = (rowValue) => {
    refRowSelected.current = rowValue;
    // console.log(rowValue);

    const strStartDate = moment(rowValue.FLEX_TIME_REQUEST_START_DATE).format(
      "YYYY-MM-DD"
    );
    // console.log(strStartDate);

    if (moment(strStartDate).isSameOrBefore(moment().format("YYYY-MM-DD"))) {
      ToastMessageError({
        message: "คุณจำเป็นต้องยกเลิกล่วงหน้าอย่างน้อย 1 วัน",
      });
      return;
    }
    if (rowValue.FLEX_TIME_REQUEST_STATUS == "2") {
      ToastMessageError({
        message: "Cannot delete because already reject !",
      });
      return;
    }

    setIsShowDeleteFlexTimeModel(true);
  };

  const onClickUploadFile = (rowValue) => {
    refRowSelected.current = rowValue;
    setIsShowUploadFileModel(true);
  };

  const generateSortingIndicator = (column) => {
    return <GenerateSortingIndicator column={column} />;
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  // columns
  const columns = useMemo(
    () => [
      // {
      //   Header: t("Actions"),
      //   disableFilters: true,
      //   disableSortBy: true,
      //   Cell: (cellProps) => {
      //     // console.log(cellProps.row.original);
      //     return (
      //       <UncontrolledButtonDropdown>
      //         <DropdownToggle
      //           className="icon-btn hide-arrow"
      //           color="transparent"
      //           size="sm"
      //           caret
      //           style={{ padding: 0 }}
      //         >
      //           <MoreVertical size={15} />
      //         </DropdownToggle>
      //         <DropdownMenu container="body">
      //           <DropdownItem
      //             href="/"
      //             onClick={(e) => {
      //               // e.preventDefault();
      //               // onClickDelete(cellProps.row.original);

      //               e.preventDefault();
      //               cellProps.row.original.INUSE == "1"
      //                 ? onClickDelete(cellProps.row.original)
      //                 : ToastMessageError({
      //                     message: "Cannot delete because already deleted !",
      //                   });
      //             }}
      //           >
      //             <Trash className="me-50" size={15} color="#F46A6A" />{" "}
      //             <span className="align-middle">{t("Delete")}</span>
      //           </DropdownItem>
      //         </DropdownMenu>
      //       </UncontrolledButtonDropdown>
      //     );
      //   },
      // },
      {
        Header: t("Status"),
        accessor: "FLEX_TIME_REQUEST_STATUS",
        disableFilters: true,
        disableSortBy: true,
        Cell: (cellProps) => {
          if (cellProps.row.original.INUSE === 0) {
            return <InuseColumn value={cellProps.row.original.INUSE} />;
          } else {
            return <StatusColumn {...cellProps} />;
          }
        },
      },
      {
        Header: t("Approval"),
        accessor: "APPROVER",
        disableFilters: true,
        disableSortBy: true,
        Cell: (cellProps) => {
          return (
            <FlexTimeListColumn {...cellProps} isFetchData={isFetchData} />
          );
        },
      },
      {
        Header: t("Time to Work"),
        accessor: "FLEX_TIME_DESCRIPTION",
        disableFilters: true,
        disableSortBy: true,
        Cell: (cellProps) => {
          return <NormalColumn {...cellProps} />;
        },
      },
      {
        Header: t("Flex Time Date"),
        accessor: "LEAVE_DATE_RANGE",
        disableFilters: true,
        disableSortBy: true,
        Cell: (cellProps) => {
          return <DateRangeColumn {...cellProps} />;
        },
      },
      {
        Header: t("Request Flex Time Date"),
        accessor: "CREATE_DATE",
        filterable: true,
        Cell: (cellProps) => {
          return <NormalColumn {...cellProps} />;
        },
      },
      {
        Header: t("Update Date"),
        accessor: "UPDATE_DATE",
        filterable: true,
        Cell: (cellProps) => {
          return <NormalColumn {...cellProps} />;
        },
      },
      {
        Header: t("Update By"),
        accessor: "UPDATE_BY",
        filterable: true,
        Cell: (cellProps) => {
          return <NormalColumn {...cellProps} />;
        },
      },
    ],
    [t]
  );

  // redux
  const [{ queryPageIndex, queryPageSize, totalCount, querySortBy }, dispatch] =
    useReducer(reducer, initialState);

  // react-query
  //#region react-query => search-data
  const onSuccessSearchData = (data) => {
    setIsFetchData(false);
    setIsSearchDataForSearchForm(false);

    if (data.data && data.data.Status == true) {
      dispatch({
        type: TOTAL_COUNT_CHANGED,
        payload: data.data.ResultOnDb[0][0].TOTAL_COUNT,
      });
    } else {
      const message = {
        title: "Search Flex Time Request",
        message: data.data.Message,
      };

      ToastMessageError(message);
      dispatch({
        type: TOTAL_COUNT_CHANGED,
        payload: 0,
      });
    }
  };

  const onErrorSearchData = (error) => {
    setIsFetchData(false);
    setIsSearchDataForSearchForm(false);

    const message = {
      title: "Search Flex Time Request",
      message: error.Message,
    };
    ToastMessageError(message);
    dispatch({
      type: TOTAL_COUNT_CHANGED,
      payload: 0,
    });
  };

  const { isLoading, error, data, isSuccess, isFetching } =
    useSearchHistoryInFlowManager(
      onSuccessSearchData,
      onErrorSearchData,
      getUrlParamSearch(
        queryPageIndex,
        queryPageSize,
        querySortBy,
        getValues(),
        startPicker,
        endPicker
      ),
      isFetchData
    );
  //#endregion react-query => search-data

  // table
  const table = useTable(
    {
      columns,
      data:
        isSuccess && data.data.Status == true ? data.data.ResultOnDb[1] : [],
      initialState: {
        pageIndex: queryPageIndex,
        pageSize: queryPageSize,
        sortBy: querySortBy,
      },
      manualSortBy: true,
      manualPagination: true,
      pageCount: isSuccess ? Math.ceil(totalCount / queryPageSize) : null,
      autoResetSortBy: false,
      autoResetExpanded: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, sortBy },
  } = table;

  // useEffect
  useEffect(() => {
    refTableData.current = table;
  }, []);

  useEffect(() => {
    dispatch({ type: PAGE_CHANGED, payload: pageIndex });
    dispatch({ type: PAGE_SIZE_CHANGED, payload: pageSize });
    dispatch({ type: PAGE_SORT_CHANGED, payload: sortBy });

    setIsFetchData(true);
  }, [pageIndex, pageSize, gotoPage, sortBy]);

  useEffect(() => {
    gotoPage(0);
  }, [sortBy, pageSize]);

  if (error) {
    return <p>{error.message}</p>;
  }

  if (isLoading) {
    return (
      <p className="card-text placeholder-glow">
        <span className="placeholder col-7"></span>
        <span className="placeholder col-4"></span>
        <span className="placeholder col-4"></span>
        <span className="placeholder col-6"></span>
        <span className="placeholder col-8"></span>
      </p>
    );
  }

  const Loader = () => {
    return (
      <Fragment>
        <Spinner />
        <CardText>Loading data...</CardText>
      </Fragment>
    );
  };

  return (
    <>
      {/* <FlexTimeHistoryDeleteModal
        refRowSelected={refRowSelected}
        isShowDeleteFlexTimeModel={isShowDeleteFlexTimeModel}
        setIsShowDeleteFlexTimeModel={setIsShowDeleteFlexTimeModel}
        setIsFetchData={setIsFetchData}
      /> */}

      <Card className="overflow-hidden">
        <CardHeader className="border-bottom">
          <CardTitle tag="h4">{t("Search result")}</CardTitle>
          {/* <CardSubtitle tag="h6" style={{ color: "red" }}>
            {t("*Please always check latest request date first")}
          </CardSubtitle> */}
        </CardHeader>

        <CardBody style={{ paddingBottom: "10px" }}>
          <Row className="mt-1 mb-0">
            <Col sm="6">
              {page.length > 0 && (
                <div className="d-flex align-items-center">
                  <Label for="sort-select">{t("Show")}</Label>
                  <Input
                    className="dataTable-select"
                    type="select"
                    id="sort-select"
                    value={pageSize}
                    onChange={onChangeInSelect}
                    style={{ width: "5rem" }}
                  >
                    {[5, 10, 15, 20, 25].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </Input>
                  <Label for="sort-select">{t("entries")}</Label>
                </div>
              )}
            </Col>
            <Col
              className="d-flex align-items-center justify-content-sm-end mt-sm-0 mt-1"
              sm="6"
              style={{ paddingRight: "3px" }}
            ></Col>
          </Row>
        </CardBody>
        {page.length > 0 ? (
          <UILoader blocking={isFetching || isLoading} loader={<Loader />}>
            <div className="table-responsive react-table  mb-50">
              {isSuccess ? (
                <Table bordered hover responsive {...getTableProps()}>
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr
                        key={headerGroup.id}
                        {...headerGroup.getHeaderGroupProps()}
                      >
                        {headerGroup.headers.map((column) => (
                          <th
                            scope="col"
                            className="text-nowrap"
                            key={column.id}
                          >
                            <div {...column.getSortByToggleProps()}>
                              {column.render("Header")}
                              {generateSortingIndicator(column)}
                            </div>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>

                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <Fragment key={row.getRowProps().key}>
                          <tr>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  scope="col"
                                  className="text-nowrap"
                                  key={cell.id}
                                  {...cell.getCellProps()}
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        </Fragment>
                      );
                    })}
                  </tbody>
                </Table>
              ) : null}
            </div>
            <Row className="justify-content-md-end justify-content-center align-items-center my-1 px-1">
              <Col className="col-md-auto d-none d-md-block">
                <strong>
                  {t("Showing")} {pageIndex * pageSize + 1} {t("to")}{" "}
                  {pageIndex * pageSize +
                    (data?.data?.ResultOnDb[1]?.length || 0)}{" "}
                  {t("of")} {data?.data.ResultOnDb[0][0].TOTAL_COUNT}{" "}
                  {t("entries")}
                </strong>
              </Col>
              <Col className="col-md-auto">
                <div className="d-flex gap-1">
                  <Button
                    color="primary"
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                    className="small-btn"
                  >
                    {"<<"}
                  </Button>
                  <Button
                    color="primary"
                    onClick={previousPage}
                    disabled={!canPreviousPage}
                    className="small-btn"
                  >
                    {"<"}
                  </Button>
                </div>
              </Col>
              <Col className="col-md-auto d-none d-md-block">
                {t("Page")}{" "}
                <strong>
                  {pageIndex + 1} {t("of")} {pageOptions.length}
                </strong>
              </Col>
              <Col className="col-md-auto">
                <Input
                  type="number"
                  min={1}
                  style={{ width: 70 }}
                  max={pageOptions.length}
                  placeholder={pageIndex + 1}
                  onChange={onChangeInInput}
                  className="small-input-page"
                />
              </Col>

              <Col className="col-md-auto">
                <div className="d-flex gap-1">
                  <Button
                    color="primary"
                    onClick={nextPage}
                    disabled={!canNextPage}
                    className="small-btn"
                  >
                    {">"}
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => gotoPage(pageCount - 1)}
                    disabled={!canNextPage}
                    className="small-btn"
                  >
                    {">>"}
                  </Button>
                </div>
              </Col>
              <div
                style={{ marginTop: "1rem", textAlign: "center" }}
                className="small-block"
              >
                <Col className="col-md-auto d-md-block">
                  <strong>
                    {t("Showing")} {pageIndex * pageSize + 1} {t("to")}{" "}
                    {pageIndex * pageSize +
                      (data?.data?.ResultOnDb[1]?.length || 0)}{" "}
                    {t("of")} {data?.data.ResultOnDb[0][0].TOTAL_COUNT}{" "}
                    {t("entries")}
                  </strong>
                </Col>
              </div>
            </Row>
          </UILoader>
        ) : (
          <NoResultsFound />
        )}
      </Card>
    </>
  );
};

export default CheckSubordinateFlexTimeTableData;
